export default __webpack_public_path__ + "static/media/4.4b855a09.png";